import { useSelector as useReduxSelector, TypedUseSelectorHook } from 'react-redux'

import { AppStore } from 'core/redux/store'

const useSelector: TypedUseSelectorHook<AppStore> = useReduxSelector

export default useSelector
